// extracted by mini-css-extract-plugin
export default {"container":"EditClient_container__-aU1Y"};